import timestampedResources from './booleans.json' with { type: 'json' };
export default timestampedResources;
